import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Seo } from "@/components/Seo";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setError("");
    setSaving(true);
    try {
      await api.post("/auth/set-password", { token, password });
      window.location.replace("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setSaving(false);
    }
  };

  return (
    <div data-testid="set-password-page" className="bg-brand-subtle min-h-[70vh] flex items-center justify-center px-4 py-16">
      <Seo title="Set Your Password | Central Air Depot" description="Choose a password to activate your Central Air Depot account." noindex />
      <div className="bg-white border border-zinc-200 rounded-sm p-8 w-full max-w-md">
        <KeyRound className="w-8 h-8 text-brand mb-3" />
        <h1 className="font-heading font-black text-2xl text-brand-ink">Set your password</h1>
        <p className="text-sm text-zinc-600 mt-2">Choose a password (at least 8 characters) to activate your Central Air Depot account.</p>
        {!token ? (
          <p data-testid="set-password-missing-token" className="mt-6 text-sm text-brand-red font-medium">
            This link is missing its invite code. Please use the exact link from your invitation email, or <Link to="/contact" className="underline">contact us</Link> for a new one.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <Input data-testid="set-password-input" type="password" required minLength={8} placeholder="New password"
              value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-sm" />
            <Input data-testid="set-password-confirm-input" type="password" required minLength={8} placeholder="Confirm password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} className="rounded-sm" />
            {error && <p data-testid="set-password-error" className="text-sm text-brand-red font-medium">{error}</p>}
            <button type="submit" disabled={saving} data-testid="set-password-submit-btn"
              className="w-full bg-brand hover:bg-brand-dark disabled:opacity-60 text-white font-bold px-6 py-3 rounded-sm transition-colors duration-200 flex items-center justify-center gap-2">
              {saving && <Loader2 className="w-4 h-4 animate-spin" />} Activate My Account
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
